<ds-modal
  [heading]="headingKey | translate"
  (closeClick)="close('cancel')"
  [closeCaption]="'overview.autopay-promo.details.close-caption' | translate"
  [size]="'large'"
>
  <div body>
    <ss-autopay-discount-table [autopayDiscountData]="discountRows"></ss-autopay-discount-table>

    <div class="d-flex flex-sm-row flex-column gap-16 gap-sm-24 mt-24">
      <a
        ds-button
        [attr.aria-label]="'overview.autopay-promo.details.setup-cta-alt' | translate"
        [attr.title]="'overview.autopay-promo.details.setup-cta-alt' | translate"
        [routerLink]="[CHANGE_PAYMENT_METHOD_URL]"
        (click)="close()"
      >
        {{ 'overview.autopay-promo.details.setup-cta' | translate }}
      </a>

      <button
        ds-button
        [variant]="'secondary'"
        [attr.title]="'overview.autopay-promo.details.cancel-alt' | translate"
        [attr.aria-label]="'overview.autopay-promo.details.cancel-alt' | translate"
        (click)="close()"
      >
        {{ 'global.cta.cancel' | translate }}
      </button>
    </div>
  </div>
</ds-modal>
